<template>
  <main>
    <OrganismLogin/>
  </main>
</template>

<script>
export default {
  name: 'Login',

  components: {
    OrganismLogin: () => import('@/components/organisms/OrganismLogin')
  }
}
</script>
